import { render, staticRenderFns } from "./TrademarkTypeList.vue?vue&type=template&id=3aab0092&"
import script from "./TrademarkTypeList.vue?vue&type=script&lang=js&"
export * from "./TrademarkTypeList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkTypeList.vue?vue&type=style&index=0&id=3aab0092&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports